jQuery(document).ready(function() {
    if (typeof gform !== 'undefined') {
        gform.addFilter('gform_datepicker_options_pre_init', function(optionsObj) {
            optionsObj.firstDay = 1;
            return optionsObj;
        });
    }
});
